import { render, staticRenderFns } from "./ParamDetails.vue?vue&type=template&id=7723fab9&scoped=true"
import script from "./ParamDetails.vue?vue&type=script&lang=js"
export * from "./ParamDetails.vue?vue&type=script&lang=js"
import style0 from "./ParamDetails.vue?vue&type=style&index=0&id=7723fab9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7723fab9",
  null
  
)

export default component.exports